import { Options } from '@angular-slider/ngx-slider';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { formatCash } from 'src/app/util/format-cash';
import { AppCurrencyPipe } from '../../shared/pipes/app-currency.pipe';


@Component({
  selector: 'app-apg-sum-assured',
  templateUrl: './apg-sum-assured.component.html',
  styleUrls: ['./apg-sum-assured.component.scss'],
})
export class ApgSumAssuredComponent implements OnInit {
  @Output() sumAssuredChanged = new EventEmitter<{ sumAssured: number }>();

  value: number;
  enteredValue: number;

  options: Options = {
    floor: 20000,
    ceil: 1000000,
    step: 5000,
    showTicks: true,
    hidePointerLabels: true,
    hideLimitLabels: true,
    showTicksValues: false,
    bindIndexForStepsArray: true,
    enforceStep: false,
    ticksArray: [20000, 100000, 250000, 500000, 750000, 1000000],
    getLegend: x => `<span>${this.currencyPipe.transform(x)}</span><span class='sm'>£${formatCash(x, 0)}</span>`,
  };

  constructor(private currencyPipe: AppCurrencyPipe) {
  }

  ngOnInit() {
    this.value = this.enteredValue = 100000;
    this.sumAssuredChanged.emit({ sumAssured: this.value });
  }

  valueChanged(value: number) {
    this.value = this.enteredValue = value;
    this.sumAssuredChanged.emit({ sumAssured: value });
  }
}

